/* MIcase · assets/micase-cajon-xsell.js · 18 de agosto de 2026
   LA RECOMENDACION DEL CAJON DEL CARRITO.

   ==================================================================================
   v3 · RECOMIENDA POR CUPO, NO POR "SI LO TIENE"
   ==================================================================================
   La v1 ofrecia SIEMPRE otra funda. La v2 ofrecia lo que faltara. Ninguna de las dos era lo
   que Sebastian queria, y la frase que lo cierra es suya:

     "El enfoque esta en que agregue una funda mas, pero DESPUES de que le agrega una funda
      mas, aprovechemos y ofrezcamosle cosas."

   O sea: llevar una funda NO cierra la categoria funda. La segunda funda es la palanca
   elegida de ticket promedio y se sigue ofreciendo hasta que la tome; solo entonces pasa el
   turno a los complementos. Eso no se puede expresar con "lo tiene / no lo tiene": hace falta
   un CUPO por categoria.

   COMO SE DECIDE QUE MOSTRAR. No es "que le falta", es "de que le falta CUPO":
     1. Se cuenta cuantas unidades de cada categoria hay en el carrito.
     2. Se recorre la lista de prioridad y se elige la PRIMERA categoria que no haya llenado
        su cupo y que ademas tenga producto disponible para ese modelo.
     3. Si todas llenaron su cupo, se intenta el relleno (mas fundas).
     4. Si tampoco hay relleno, el bloque no se pinta. Mejor nada que ruido.

   COMO SE SABE LA CATEGORIA DE LO QUE HAY EN EL CARRITO. /cart.js NO trae las etiquetas del
   producto, asi que no se puede leer cat:funda de ahi. Pero el HTML que ya se pide para las
   tarjetas SI trae data-cat por producto, asi que se construye un mapa id->categoria con el
   y se resuelve cada linea del carrito por su product_id. Lo que no aparezca en ese mapa cae
   a la misma heuristica por titulo que usa el Liquid del combo, y en el mismo orden: funda
   primero, porque "Case Armadura Magnetico Camara" es una funda y no un protector de camara.

   EL CARRIL. Sebastian: "maximo tres deslizables, para que ahorremos espacio y la persona
   pueda mover hacia la derecha". Se ve UNA tarjeta y la siguiente asoma. Tres es el techo.

   Y LLEVA FLECHAS, aunque el corte ya invitaba a deslizar. Sebastian lo probo y no pudo:
   "no me permite deslizar hacia el lado". Un carril que depende SOLO del gesto es fragil por
   partido doble: dentro de un navegador incrustado -el de Claude, el de Instagram, el de
   Facebook, que es el 35,3 % del trafico- el arrastre horizontal se lo puede quedar la app
   para su propio "volver atras", y en escritorio con raton no hay gesto ninguno. Las dos
   flechas no suman NADA de alto porque van superpuestas en el margen del carril, y se
   esconden solas cuando no hay a donde ir. El gesto sigue funcionando para quien lo use.
   ==================================================================================

   ==================================================================================
   v4 · EL MODELO LO MANDA LA FICHA, NO EL CARRITO
   ==================================================================================
   Sebastian: "cuando la persona agrega algo ahi, se agrega para el modelo relevante? O sea,
   literalmente para el modelo en el que la persona esta en la product page deberia ser lo
   ideal, porque si no, como elige el modelo ahi?".

   La respuesta a la primera parte era que SI: lo que se agrega ya era la variante exacta de
   un modelo, porque el id sale del formulario que emitio el Liquid del combo para ESE modelo.
   Nunca se agrego nada "sin modelo". Pero la segunda parte era un fallo real de eleccion de
   fuente: el modelo se tomaba de la LINEA DE MAYOR VALOR DEL CARRITO, y esa no siempre es la
   que la persona esta mirando. Si en el carrito hay una funda de Xiaomi 15 y la persona esta
   en la ficha de un POCO X7, lo que tiene delante es el POCO X7.

   AHORA MANDA LA FICHA, con el mismo criterio que ya usa sections/micase-similares desde el
   30 de julio ("LA VARIANTE MANDA"): se lee #mccombo-model, que es el nombre del modelo VIVO
   -el que refleja el selector de la pagina, no el que respondio en el quiz hace dias-. Solo
   cuando no hay ficha delante -el cajon abierto desde una coleccion o desde el carrito- se
   cae a la linea de mayor valor del carrito.

   Y PARA QUE NO HAYA QUE CREERSELO, cada tarjeta lleva escrito debajo del nombre para que
   modelo es. La duda de Sebastian se contesta sola en pantalla.
   ==================================================================================

   POR QUE AQUI Y NO EN LA FICHA. Antes de decidir, una alternativa genera duda; por eso
   sections/micase-similares vive al fondo de la ficha, discreta. Despues de decidir ya no hay
   decision que estropear. Ese momento es este: el cajon, justo despues de agregar.

   DE DONDE SALEN LAS TARJETAS. Del mismo endpoint que ya usa el combo de la ficha. No se
   duplica ni el marcado ni el calculo del precio por variante: se leen del HTML que devuelve
   Liquid, que es la unica fuente del precio. Y como el combo ya descarta lo que no tiene
   variante disponible para ese modelo (regla 79), aqui no puede colarse un agotado.

   POR QUE LO INYECTA EL JS Y NO LIQUID. Dawn reemplaza el interior de #CartDrawer entero en
   cada cambio del carrito: un bloque puesto por Liquid ahi dentro se borraria solo.

   NADA SE ESCRIBE A MANO: los textos entran por los atributos data- de #mcxf-cfg (regla 40),
   que emite sections/micase-cajon-xsell.liquid con sus ajustes del editor.
*/
(function () {
  var cfg = document.getElementById('mcxf-cfg');
  if (!cfg || cfg.getAttribute('data-on') !== 'true') return;

  /* 2026-08-18 · EL ID DE SECCION NO SE ESCRIBE A MANO (regla 73). En una plantilla .json el
     id que acepta la Section Rendering API es el que Shopify genera, no la clave del JSON. El
     unico valor que se sabe bueno es el que el propio combo ya usa con exito: su data-sid. */
  function sidBueno() {
    var c = document.getElementById('mccombo');
    var s = c && c.getAttribute('data-sid');
    return s || cfg.getAttribute('data-sid') || 'micase_combo';
  }
  var MAX = parseInt(cfg.getAttribute('data-max'), 10); if (!(MAX > 0)) MAX = 3;
  var T_ADD = cfg.getAttribute('data-boton') || 'Agregar';
  var T_MINI = cfg.getAttribute('data-mini') || '';

  /* DOS PASADAS, y la diferencia entre ellas es TODA la logica de este bloque.

     PASADA 1 · EL CUPO. Cada categoria tiene un techo de cuantas unidades justifican seguir
     ofreciendola, y se ofrece la primera que no lo haya llenado. Los cupos por defecto son
     funda 2, pantalla 1 y camara 1, y cada numero tiene su motivo:

       · FUNDA 2, no 1. Llevar una funda NO cierra la categoria: la segunda funda es la
         palanca elegida de ticket promedio -260 pedidos ya se llevan dos sin que nadie se lo
         pida- y por eso se ofrece hasta que la tome. Cuando ya lleva dos, pasa el turno.
       · PANTALLA 1 y CAMARA 1, porque son EXCLUYENTES: nadie pone dos vidrios en el mismo
         celular. Ofrecer el segundo no puede sumar un peso al pedido.
       · TRASERO no entra en la lista: 15 pedidos en 180 dias no justifican ocupar el unico
         hueco que hay.

     El orden -funda, pantalla, camara- sigue el peso comercial: 859 pedidos con funda, 434
     con protector de pantalla, 110 con protector de camara.

     PASADA 2 · EL RELLENO. Si todas las categorias llenaron su cupo, o si el modelo no tiene
     complementos que ofrecer, se intenta con mas fundas. Es la unica categoria que admite
     repetirse sin limite razonable, porque dos fundas conviven y se alternan.

     Las listas y los cupos son ajustes, no constantes: el dia que el catalogo cambie de
     forma, se cambian desde el editor y no desde el codigo. */
  function lista(attr, porDefecto) {
    return (cfg.getAttribute(attr) || porDefecto)
      .split(',').map(function (s) { return s.trim() }).filter(Boolean);
  }
  var PRIO = lista('data-prio', 'funda,pantalla,camara');
  var RELLENO = lista('data-relleno', 'funda');

  /* Cupos, en el formato  categoria:numero,categoria:numero. Lo que no aparezca vale 1. */
  var CUPO = (function () {
    var m = {}, p = lista('data-cupo', 'funda:2,pantalla:1,camara:1'), i, kv, n;
    for (i = 0; i < p.length; i++) {
      kv = p[i].split(':');
      n = parseInt(kv[1], 10);
      if (kv[0] && n > 0) m[kv[0].trim()] = n;
    }
    return m;
  })();
  function cupoDe(cat) { return CUPO[cat] > 0 ? CUPO[cat] : 1; }

  /* Un par de textos por categoria, y uno generico para cuando ya la tiene.

     LA DISTINCION NO ES COSMETICA, y no depende de la categoria sino de SI YA LA TIENE.
     Ofrecer una funda a quien no tiene ninguna es "te falta la funda"; ofrecersela a quien ya
     lleva una es "dos viajan por lo mismo que una". Con un solo texto, el que entro por un
     vidrio leia "sumale OTRA" sin tener ninguna, y la frase se cae sola.

     Asi que: si el carrito YA tiene algo de esa categoria, el texto es el de ADICION
     (data-titulo / data-sub); si no, el del HUECO de esa categoria (data-titulo-<categoria>).

     Si a una categoria le falta su texto se usa el generico: nunca se queda sin encabezado. */
  function textos(cat, esAdicion) {
    var t = esAdicion ? '' : (cfg.getAttribute('data-titulo-' + cat) || '');
    var s = esAdicion ? '' : (cfg.getAttribute('data-sub-' + cat) || '');
    return {
      t: t || cfg.getAttribute('data-titulo') || '',
      s: s || cfg.getAttribute('data-sub') || ''
    };
  }

  var ultimoHandle = null, ultimaFirma = null, pintando = false;
  /* 2026-08-21 · EL BLOQUE NO SE RECONSTRUYE: SE VUELVE A COLGAR.
     Reportado por Sebastian: al abrir el cajon por primera vez, el carril aparecia,
     desaparecia y volvia a aparecer. Causa: Dawn reemplaza TODO el interior de
     #CartDrawer al agregar algo y se lleva por delante este nodo; el vigilante del final
     esperaba 120 ms y ademas volvia a pedir /cart.js y el HTML de la coleccion antes de
     poder pintar nada. Ese hueco es el parpadeo.
     Ahora se guarda la REFERENCIA al nodo. Aunque Dawn lo saque del documento, el nodo
     sigue VIVO en memoria con sus tarjetas dentro: basta con volver a colgarlo en el
     mismo instante, sin pedir nada, y el cliente no ve el salto. Solo se construye de
     cero cuando todavia no existe. */
  var nodo = null;
  /* Ultimo estado conocido del carrito. Lo mira el vigilante de abajo para no volver a
     inyectar el bloque -ni pedir /cart.js- cada vez que Dawn repinta un cajon vacio. */
  var carritoVacio = false;

  function mchandle(s) {
    if (window.MCModelo && window.MCModelo.handle) return window.MCModelo.handle(s);
    return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\+/g, ' plus ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Mismo orden que el Liquid del combo, y el orden ES la logica: funda primero, porque
     "Case Armadura Magnetico Camara" es una funda. Solo se usa como respaldo, cuando el
     producto del carrito no esta en el HTML de las tarjetas de ese modelo. */
  function catPorTitulo(t) {
    t = String(t || '').toLowerCase();
    if (/case|forro|funda|policromo|silicone|glitter|carbono/.test(t)) return 'funda';
    if (/trasero/.test(t)) return 'trasero';
    if (/cámara|camara/.test(t)) return 'camara';
    if (/hidrogel|vidrio|protector/.test(t)) return 'pantalla';
    return 'otro';
  }

  function mapaCategorias(items) {
    var m = {}, i, n, pid;
    if (!items) return m;
    for (i = 0; i < items.children.length; i++) {
      n = items.children[i];
      pid = n.getAttribute('data-pid');
      if (pid) m[String(pid)] = n.getAttribute('data-cat') || 'otro';
    }
    return m;
  }

  /* El modelo sale del valor de la opcion que se llame "Modelo". Si el producto no tiene esa
     opcion -un accesorio- devuelve null y esa linea no puede mandar. */
  function modeloDe(item) {
    var o = (item && item.options_with_values) || [];
    for (var i = 0; i < o.length; i++) {
      if (/modelo/i.test(String(o[i].name || ''))) return o[i].value || null;
    }
    return null;
  }

  /* Linea de MAYOR VALOR con modelo. line_price ya viene en centavos y con la cantidad
     multiplicada, que es justo lo que hay que comparar. */
  function lineaQueManda(cart) {
    var its = (cart && cart.items) || [], mejor = null, i, m;
    for (i = 0; i < its.length; i++) {
      m = modeloDe(its[i]);
      if (!m) continue;
      if (!mejor || (its[i].line_price || 0) > (mejor.line_price || 0)) {
        mejor = its[i]; mejor.__modelo = m;
      }
    }
    return mejor;
  }

  function idsEnCarrito(cart) {
    var s = {}, its = (cart && cart.items) || [];
    for (var i = 0; i < its.length; i++) { if (its[i].product_id) s[String(its[i].product_id)] = 1; }
    return s;
  }

  /* UNIDADES por categoria, no productos distintos: quien pidio dos veces la misma funda ya
     tiene dos fundas, y la categoria debe darse por cubierta igual. */
  function unidadesPorCat(cart, mapa) {
    var s = {}, its = (cart && cart.items) || [], i, c, q;
    for (i = 0; i < its.length; i++) {
      c = mapa[String(its[i].product_id)] || catPorTitulo(its[i].product_title || its[i].title);
      if (!c) continue;
      q = parseInt(its[i].quantity, 10); if (!(q > 0)) q = 1;
      s[c] = (s[c] || 0) + q;
    }
    return s;
  }

  /* EL MODELO DE LA FICHA. #mccombo-model lo pinta micase-combo con la variante VIVA, o sea
     con lo que el selector de la pagina tiene elegido en este momento. Es la misma fuente que
     usa sections/micase-similares, y tomarla del mismo nodo es lo que impide que las dos
     superficies se contradigan. Si no hay ficha delante, devuelve null. */
  function modeloDeLaFicha() {
    var n = document.getElementById('mccombo-model');
    var v = n ? String(n.textContent || '').trim() : '';
    return v || null;
  }

  function firma(cart) {
    var its = (cart && cart.items) || [], p = [];
    for (var i = 0; i < its.length; i++) { p.push(its[i].variant_id + 'x' + its[i].quantity); }
    return p.join('|');
  }

  /* El modelo de la ficha puede cambiar SIN que cambie el carrito -la persona toca otro
     modelo en el selector con el cajon cerrado-, asi que vigilarlo es obligatorio: si no, el
     bloque se quedaria ofreciendo complementos del modelo anterior. Es el mismo observador
     que ya usa sections/micase-similares sobre el mismo nodo. */
  function vigilaModelo() {
    var m = document.getElementById('mccombo-model');
    if (!m || typeof MutationObserver !== 'function') return;
    new MutationObserver(function () { ultimaFirma = null; lee(); })
      .observe(m, { childList: true, characterData: true, subtree: true });
  }

  function anclaDelCajon() {
    var host = document.getElementById('CartDrawer');
    if (!host) return null;
    return host.querySelector('.drawer__footer') || host.querySelector('.drawer__inner') || host;
  }

  function cuelga(d, ancla) {
    if (ancla.classList && ancla.classList.contains('drawer__footer')) {
      ancla.parentNode.insertBefore(d, ancla);
    } else {
      ancla.appendChild(d);
    }
  }

  /* 2026-08-22 · LA VERDAD DEL CAJON VACIO ESTA EN EL DOM, NO EN LA VARIABLE.
     Sebastian, con captura: con el carrito vacio se veian a la vez el bloque de "aqui no hay
     fundas genericas" y el pie con el cupon, "Total estimado $0 COP" y "Pagar pedido".
     Lo rompi YO esta misma manana. El arreglo del parpadeo al cambiar la cantidad metio
     reengancha() DENTRO del observador, y ahi la guarda era `carritoVacio`, que es un valor
     CACHEADO: cuando el cliente borra la ultima linea, Dawn repinta el cajon vacio de
     inmediato y /cart.js no contesta hasta unos 300 ms despues, asi que en ese hueco
     carritoVacio todavia vale false, el bloque se vuelve a colgar entre cart-drawer-items y
     .drawer__footer, y se rompe el selector de hermano adyacente con el que Dawn esconde el
     pie (assets/component-cart-drawer.css: cart-drawer-items.is-empty + .drawer__footer).
     Hasta hoy no pasaba porque el bloque solo se colgaba dentro de caja(), y a caja() solo se
     llega desde pinta() DESPUES de comprobar item_count > 0.
     El DOM ya lo dice sin esperar a nadie: Dawn marca .is-empty al pintar. Se pregunta ahi. */
  function vacioEnElDOM() {
    return !!document.querySelector('cart-drawer.is-empty, cart-drawer-items.is-empty');
  }

  /* Saca el bloque del DOM sin tocar el estado. No es quita(): aqui no se sabe todavia si el
     carrito quedo vacio de verdad o si Dawn esta a mitad de un repintado, asi que no se suelta
     la referencia ni se marca nada. Lo unico que importa es que el pie recupere a su hermano. */
  function descuelga() {
    var v = document.getElementById('mcxf');
    if (v && v.parentNode) v.parentNode.removeChild(v);
  }

  /* Devuelve true si el bloque ya esta colgado o si se acaba de recolgar sin pedir nada. */
  function reengancha() {
    if (carritoVacio || vacioEnElDOM() || !nodo) return false;
    if (nodo.isConnected) return true;
    var ancla = anclaDelCajon();
    if (!ancla) return false;
    cuelga(nodo, ancla);
    return true;
  }

  function caja() {
    var ancla = anclaDelCajon();
    if (!ancla) return null;
    if (nodo && !nodo.isConnected) { cuelga(nodo, ancla); return nodo; }
    var vieja = document.getElementById('mcxf');
    if (vieja && vieja.parentNode !== ancla.parentNode) { vieja.parentNode.removeChild(vieja); vieja = null; }
    if (vieja) { nodo = vieja; return vieja; }
    var d = document.createElement('div');
    d.className = 'mcxf'; d.id = 'mcxf'; d.hidden = true;
    var h = document.createElement('p'); h.className = 'mcxf__h'; d.appendChild(h);
    var s = document.createElement('p'); s.className = 'mcxf__s'; d.appendChild(s);
    var car = document.createElement('div'); car.className = 'mcxf__carril';
    var l = document.createElement('div'); l.className = 'mcxf__lista';
    car.appendChild(flecha('izq', l));
    car.appendChild(l);
    car.appendChild(flecha('der', l));
    d.appendChild(car);
    cuelga(d, ancla);
    nodo = d;
    return d;
  }

  /* --------------------------------------------------------------------
     QUITAR EL BLOQUE DEL DOM, NO SOLO ESCONDERLO. 2026-08-18, segundo aviso de
     Sebastian con captura: con el cajon VACIO seguian saliendo "Total estimado $0 COP"
     y el boton de pagar, que Dawn esconde solos.
     LA CAUSA, y otra vez la introduje yo: Dawn apaga ese pie con un selector de
     HERMANO ADYACENTE, en assets/component-cart-drawer.css:

         cart-drawer-items.is-empty + .drawer__footer { display: none }

     El '+' exige que el pie sea el hermano INMEDIATAMENTE siguiente. Este archivo
     inserta su bloque JUSTO ANTES del pie, asi que quedaba en medio y rompia la
     adyacencia. Esconder el bloque con [hidden] no arregla nada: el nodo sigue ahi
     y el selector sigue sin casar.
     Por eso con el carrito vacio el bloque no se esconde: SE QUITA.
     -------------------------------------------------------------------- */
  function quita() {
    var vieja = document.getElementById('mcxf');
    if (vieja && vieja.parentNode) vieja.parentNode.removeChild(vieja);
    if (nodo && nodo.parentNode) nodo.parentNode.removeChild(nodo);
    /* Con el carrito vacio se suelta tambien la referencia: el bloque que vuelva a
       aparecer sera de otro carrito y no tiene por que heredar estas tarjetas. */
    nodo = null;
    ultimoHandle = null;
    ultimaFirma = null;
    carritoVacio = true;
  }

  /* Una flecha. type="button" no es opcional: dentro del cajon hay formularios y un boton sin
     tipo los enviaria. Se mueve UNA tarjeta por toque, que es lo que espera el dedo. */
  function flecha(lado, lista) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mcxf__nav mcxf__nav--' + lado;
    b.setAttribute('aria-label', lado === 'izq' ? 'Ver el anterior' : 'Ver el siguiente');
    b.innerHTML = lado === 'izq' ? '&#8249;' : '&#8250;';
    b.hidden = true;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var t = lista.querySelector('.mcxf__it');
      var paso = t ? (t.offsetWidth + 8) : Math.round(lista.clientWidth * 0.9);
      var x = lista.scrollLeft + (lado === 'izq' ? -paso : paso);
      if (lista.scrollTo) { try { lista.scrollTo({ left: x, behavior: 'smooth' }) } catch (err) { lista.scrollLeft = x } }
      else { lista.scrollLeft = x; }
    });
    return b;
  }

  /* Las flechas se esconden solas en los extremos. El margen de 2 px absorbe los decimales
     que deja el redondeo del navegador al medir anchos en porcentaje. */
  function ajustaFlechas(d2) {
    var lista = d2.querySelector('.mcxf__lista');
    var izq = d2.querySelector('.mcxf__nav--izq');
    var der = d2.querySelector('.mcxf__nav--der');
    if (!lista || !izq || !der) return;
    var hay = lista.scrollWidth - lista.clientWidth > 2;
    izq.hidden = !hay || lista.scrollLeft <= 2;
    der.hidden = !hay || lista.scrollLeft >= lista.scrollWidth - lista.clientWidth - 2;
  }

  function tarjeta(nodo, modelo) {
    var img = nodo.querySelector('.mccombo__img img');
    var tit = nodo.querySelector('.mccombo__t');
    var pre = nodo.querySelector('.mccombo__p');
    var inp = nodo.querySelector('.mccombo__f input[name="id"]');
    if (!inp || !inp.value) return null;              /* sin variante para ese modelo, fuera */
    var nombre = tit ? (tit.textContent || '').trim() : '';
    var it = document.createElement('div'); it.className = 'mcxf__it';
    var a = document.createElement('a');
    a.className = 'mcxf__lk'; a.href = tit ? (tit.getAttribute('href') || '#') : '#';
    if (img && img.getAttribute('src')) {
      var im = document.createElement('img');
      im.src = img.getAttribute('src'); im.alt = img.getAttribute('alt') || nombre;
      im.loading = 'lazy'; im.width = 36; im.height = 36;
      a.appendChild(im);
    }
    var col = document.createElement('span'); col.className = 'mcxf__tx';
    var tx = document.createElement('span'); tx.className = 'mcxf__t'; tx.textContent = nombre;
    col.appendChild(tx);
    /* El modelo, escrito en cada tarjeta. No es decoracion: contesta en pantalla la pregunta
       de "y esto para que modelo se agrega". */
    if (T_MINI && modelo) {
      var mi = document.createElement('span'); mi.className = 'mcxf__m';
      mi.textContent = String(T_MINI).split('[modelo]').join(modelo);
      col.appendChild(mi);
    }
    a.appendChild(col);
    it.appendChild(a);
    var pie = document.createElement('div'); pie.className = 'mcxf__pie';
    var pr = document.createElement('span'); pr.className = 'mcxf__p';
    pr.textContent = pre ? (pre.textContent || '').trim() : '';
    pie.appendChild(pr);
    var f = document.createElement('form');
    f.method = 'post'; f.action = '/cart/add';
    /* 2026-08-18 · LAS DOS CLASES SON OBLIGATORIAS Y LA SEGUNDA NO ES DECORATIVA. Quien
       convierte estos formularios en peticiones AJAX es assets/micase-popups.js, y su filtro
       es una lista CERRADA: form.mccombo__f, form.mcx__f (linea 325). Sin mcx__f el navegador
       enviaba el formulario a la antigua y la pagina se iba a /cart. */
    f.className = 'mcxf__f mcx__f';
    var i1 = document.createElement('input'); i1.type = 'hidden'; i1.name = 'id'; i1.value = inp.value;
    var i2 = document.createElement('input'); i2.type = 'hidden'; i2.name = 'quantity'; i2.value = '1';
    var b = document.createElement('button'); b.type = 'submit'; b.className = 'mcxf__add';
    b.textContent = T_ADD;
    b.setAttribute('aria-label', T_ADD + (nombre ? (' ' + nombre) : ''));
    f.appendChild(i1); f.appendChild(i2); f.appendChild(b);
    pie.appendChild(f);
    it.appendChild(pie);
    return it;
  }

  /* Devuelve las tarjetas de una categoria que no esten ya en el carrito, hasta MAX. */
  function candidatas(items, cat, yaEsta) {
    var out = [], i, n;
    for (i = 0; i < items.children.length && out.length < MAX; i++) {
      n = items.children[i];
      if ((n.getAttribute('data-cat') || '') !== cat) continue;
      if (yaEsta[String(n.getAttribute('data-pid') || '')]) continue;
      if (!n.querySelector('.mccombo__f input[name="id"]')) continue;
      out.push(n);
    }
    return out;
  }

  function dibuja(html, linea, cart) {
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var items = tmp.querySelector('#mccombo-items');
    var d2 = caja(); if (!d2) return;
    var lista = d2.querySelector('.mcxf__lista');
    lista.textContent = '';
    if (!items) { d2.hidden = true; return; }

    var mapa = mapaCategorias(items);
    var cuentas = unidadesPorCat(cart, mapa);
    var yaEsta = idsEnCarrito(cart);

    /* PASADA 1 · EL CUPO: la primera categoria que no haya llenado el suyo y que ademas tenga
       algo disponible para este modelo. */
    var elegidas = null, cat = null, i, c;
    for (i = 0; i < PRIO.length; i++) {
      if ((cuentas[PRIO[i]] || 0) >= cupoDe(PRIO[i])) continue;
      c = candidatas(items, PRIO[i], yaEsta);
      if (c.length) { elegidas = c; cat = PRIO[i]; break; }
    }
    /* PASADA 2 · EL RELLENO: si todas llenaron el cupo, mas fundas. */
    if (!elegidas) {
      for (i = 0; i < RELLENO.length; i++) {
        c = candidatas(items, RELLENO[i], yaEsta);
        if (c.length) { elegidas = c; cat = RELLENO[i]; break; }
      }
    }
    /* Y si tampoco hay relleno -ya se lo llevo todo-, no se pinta nada. Insistir cuando la
       compra ya esta completa es ruido, no venta. */
    if (!elegidas) { d2.hidden = true; return; }

    var puestas = 0;
    for (i = 0; i < elegidas.length; i++) {
      var t = tarjeta(elegidas[i], linea.__modelo);
      if (t) { lista.appendChild(t); puestas++; }
    }
    if (!puestas) { d2.hidden = true; return; }

    /* Una sola tarjeta no es un carril: se le quita el corte para que ocupe el ancho entero. */
    lista.classList.toggle('mcxf__lista--uno', puestas < 2);
    if (!lista.mcOye) {
      lista.mcOye = true;
      lista.addEventListener('scroll', function () { ajustaFlechas(d2) }, { passive: true });
    }
    /* Se mide en el fotograma siguiente: hasta que el navegador no ha maquetado las tarjetas,
       scrollWidth y clientWidth valen lo mismo y las flechas saldrian escondidas siempre. */
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () { ajustaFlechas(d2) });
    } else { ajustaFlechas(d2); }

    /* El testigo va entre CORCHETES, no entre llaves (reglas 50 y 72). */
    var tx = textos(cat, (cuentas[cat] || 0) > 0);
    d2.querySelector('.mcxf__h').textContent = String(tx.t).split('[modelo]').join(linea.__modelo);
    d2.querySelector('.mcxf__s').textContent = String(tx.s).split('[modelo]').join(linea.__modelo);
    d2.setAttribute('data-cat', cat);
    d2.hidden = false;
  }

  function pinta(cart) {
    /* CARRITO VACIO: NO SE RECOMIENDA NADA, Y EL BLOQUE NI SIQUIERA SE CREA.
       Reportado por Sebastian con captura: con el cajon vacio salia "Te falta la funda" con
       un modelo cualquiera. Y no es un descuido antiguo: lo introduje YO al hacer que mandara
       el modelo de la ficha. Antes el modelo salia de la linea de mayor valor del carrito,
       asi que un carrito vacio no tenia modelo y el bloque se escondia SOLO, por efecto
       secundario. Al leer el modelo de la pagina, ese efecto secundario desaparecio y quedo
       al descubierto que la condicion nunca estuvo escrita.
       ESTA COMPROBACION VA LA PRIMERA, ANTES DE caja(). Si va despues, caja() ya inserto el
       nodo entre cart-drawer-items y .drawer__footer y rompio el selector de hermano
       adyacente con el que Dawn esconde el pie del cajon vacio. Ver quita() arriba. */
    if (!cart || !(cart.item_count > 0)) { quita(); return; }
    carritoVacio = false;
    var d = caja(); if (!d) return;
    /* PRIMERO LA FICHA, DESPUES EL CARRITO. Si hay una ficha delante, el modelo que manda es
       el que la persona tiene elegido AHI. Solo sin ficha se mira la linea de mayor valor. */
    var modelo = modeloDeLaFicha();
    if (!modelo) {
      var l = lineaQueManda(cart);
      modelo = l ? l.__modelo : null;
    }
    if (!modelo) { d.hidden = true; return; }
    var linea = { __modelo: modelo };
    var h = mchandle(modelo);
    if (!h) { d.hidden = true; return; }
    var f = firma(cart);
    if (h === ultimoHandle && f === ultimaFirma) return;   /* nada cambio: no se vuelve a pedir */
    if (pintando) return;
    pintando = true;
    /* 2026-08-18 · SIN PEDIR NADA CUANDO YA ESTA PEDIDO. micase-combo publica en
       window.__mcComboItems el HTML de las tarjetas del modelo que esta mirando el cliente. */
    var yaPedido = window.__mcComboItems;
    if (yaPedido && yaPedido.handle === h && yaPedido.html) {
      pintando = false; ultimoHandle = h; ultimaFirma = f;
      dibuja(yaPedido.html, linea, cart);
      return;
    }
    /* MIcase 2026-08-20 · LA RUTA LA DECIDE EL DICCIONARIO, NO ESTE ARCHIVO.
       El nombre del desplegable no siempre es una etiqueta con productos detras
       ("Redmi Note 10 / 10s" la lleva 1 producto; "Redmi Note 10", 13). El desvio
       vive en el metaobjeto micase_modelo y lo publica snippets/micase-modelo.liquid.
       Si no cargara, rutaDe devuelve lo mismo que le dan y esto se comporta como antes. */
    var mcRuta = (window.MCModelo && MCModelo.rutaDe) ? MCModelo.rutaDe(h) : h;
    /* 2026-08-20 · LA VISTA PREVIA TIENE QUE PODER PROBARSE. Esta llamada no decia de
       que tema se sirve la pagina, asi que en una vista previa iba a buscar los
       productos al tema PUBLICADO y era imposible verificar un cambio sin publicarlo.
       En la tienda normal el rol es 'main' y esto no anade nada. */
    var previa = '';
    try {
      if (window.Shopify && Shopify.theme && Shopify.theme.id &&
          String(Shopify.theme.role || '').toLowerCase() !== 'main') {
        previa = '&preview_theme_id=' + Shopify.theme.id;
      }
    } catch (e) {}
    fetch('/collections/all/' + mcRuta + '?sort_by=best-selling&section_id=' + sidBueno() + previa)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        pintando = false; ultimoHandle = h; ultimaFirma = f;
        dibuja(html, linea, cart);
      })
      .catch(function (e) {
        pintando = false;
        console.warn('[MIcase] micase-cajon-xsell: no se pudieron pedir los productos del modelo', e);
      });
  }

  function lee() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(pinta)
      .catch(function () { });
  }

  /* Se engancha al aviso comun de "el carrito cambio" si existe, y si no se lee por cuenta
     propia. Ademas se vuelve a inyectar cuando Dawn reemplaza el interior del cajon. */
  function arranca() {
    if (window.MCcarrito && typeof window.MCcarrito.on === 'function') {
      window.MCcarrito.on(function (c) { if (c) pinta(c); else lee(); });
    }
    lee();
    vigilaModelo();
    /* 2026-08-22 · TAMBIEN SE VIGILA .drawer__inner, Y ESTO NO ES UN DETALLE.
       Sebastian: "cuando cambio la cantidad, parpadea el cross selling".

       Dawn reemplaza DOS NODOS DISTINTOS segun lo que pase, y hasta hoy aqui solo se
       vigilaba uno (assets/cart-drawer.js):

         · anadir al carrito  -> CartDrawer.renderContents(), selector '#CartDrawer'
         · cambiar la cantidad DENTRO del cajon
                              -> CartDrawerItems.getSectionsToRender(),
                                 selector '.drawer__inner'

       El observador colgaba de #CartDrawer con childList y SIN subtree, asi que al
       reemplazar el interior de .drawer__inner los hijos directos de #CartDrawer no
       cambiaban: el observador no se enteraba. El bloque desaparecia con el resto del
       interior y solo volvia cuando MCcarrito avisaba -300 ms de espera mas la lectura de
       /cart.js-, o sea medio segundo despues. Eso es el parpadeo.

       Se vigilan los dos nodos con el MISMO observador y sin subtree, que sigue siendo lo
       barato. Y como .drawer__inner MUERE cuando se reemplaza #CartDrawer entero, en cada
       aviso se vuelve a enganchar el interior nuevo. */
    var host = document.getElementById('CartDrawer');
    if (host && typeof MutationObserver === 'function') {
      var t = null;
      var interior = null;
      var mo = new MutationObserver(function () {
        vigilaInterior();
        /* cajon vacio: no hay nada que reponer, y si quedo algo colgado se saca para que el
           pie vuelva a ser hermano inmediato de cart-drawer-items. */
        if (carritoVacio || vacioEnElDOM()) { descuelga(); return; }
        /* Primero lo barato: si el nodo sigue vivo se vuelve a colgar YA, en el mismo
           microtask del cambio, antes de que el navegador pinte. Sin hueco, sin peticion. */
        if (reengancha()) return;
        clearTimeout(t);
        t = setTimeout(function () {
          if (carritoVacio || vacioEnElDOM()) { descuelga(); return; }
          if (!document.getElementById('mcxf')) { ultimaFirma = null; lee(); }
        }, 120);
      });
      function vigilaInterior() {
        var d = host.querySelector('.drawer__inner');
        if (d && d !== interior) { interior = d; mo.observe(d, { childList: true }); }
      }
      mo.observe(host, { childList: true });
      vigilaInterior();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
})();